export enum GrantsPermissions {
  GET_ACCOUNT_GRANTS = 'grants.getAccountGrants',
  MANAGE_ACCOUNT_GRANTS = 'grants.manageAccountGrants',
  // Mark a grant as paid or reverse it (covers both the mark-paid and
  // mark-unpaid actions, so clients have one permission to check).
  MARK_GRANT_AS_PAID = 'grants.markGrantAsPaid',
}
